// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter-active[data-v-181806f0] {\n  transition: $transition;\n}\n.slide-leave-active[data-v-181806f0] {\n  transition: 0.3s cubic-bezier(0, 1, 0.5, 1);\n}\n.slide-enter-to[data-v-181806f0],\n.slide-leave[data-v-181806f0] {\n  max-height: 100px;\n  overflow: hidden;\n}\n.slide-enter[data-v-181806f0],\n.slide-leave-to[data-v-181806f0] {\n  overflow: hidden;\n  max-height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
